import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "./Wrapper";
import { Image } from "@learningblocks/shared-components/lib/Image";
import SRC from "@learningblocks/exp-constants/lib/Images/power_supply_equipment.svg";
import { Settings } from "./Settings";
import { PowerButton } from "./PowerButton";
import { Cables } from "./Cables";

import "./style.scss";

export function Equipment(props) {
  return (
    <Wrapper className={` ${props.className} ps_equipment `}>
      <Image
        className="ps_equipment_image"
        src={SRC}
        alt="Power Supply Image"
      />
      <PowerButton
        className="ps_equipment_powerButton"
        onClick={props.togglePower}
      />
      <Settings
        className="ps_equipment_settings"
        settingsData={props.settingsData}
        setTimer={props.setTimer}
        setVoltage={props.setVoltage}
        setCurrent={props.setCurrent}
        onClickStart={props.onClickStart}
        onClickStop={props.onClickStop}
        interactionProps={props.interactionProps}
        alert={props.alert}
      />
      <Cables
        className="ps_equipment_cables"
        anode={props.cablesData.anode}
        cathode={props.cablesData.cathode}
      />
    </Wrapper>
  );
}

Equipment.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * callback function to toggle power state
   */
  togglePower: PropTypes.func,
  ...Settings.propTypes,
  /**
   * data containing information about cables
   */
  cablesData: PropTypes.shape({
    /**
     * specifies wire type in anode
     */
    anode: PropTypes.string,
    /**
     * specifies wire type in cathode
     */
    cathode: PropTypes.string,
  }),
};
